/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import {
  Alert,
  Avatar,
  Box,
  Button,
  Card,
  LinearProgress,
  Paper,
  Snackbar,
  Stack,
  TablePaginationProps,
  Tooltip,
  Typography,
  Grid,
  IconButton,
} from "@mui/material";
import image from "../../images/Download_icon.png";

import * as XLSX from "xlsx";
import RefreshIcon from "@mui/icons-material/Refresh";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useEffect, useState, useRef } from "react";
import classes from "./TenantUserPage.module.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import editLogo from "./EditLogo.png";
import CloseIcon from "@mui/icons-material/Close";
import MuiPagination from "@mui/material/Pagination";
import { IErrorProps, Role, UserDto, OptionsProduct } from "../../models";
import { getTenantLogo } from "../../store/Tenant/tenant-actions";
import {
  deleteTenantUser,
  exportUserListBasedOnForgeCustomerId,
  getUserListBasedOnForgeCustomerId,
  getUserPermissions,
  setFilteredUsers,
  setroleList,
} from "../../store/User/user-actions";
import {
  DataGrid,
  GridColDef,
  gridPageCountSelector,
  GridPagination,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";

import DeleteDialog from "../SharedComponents/DeleteDialog";
import QuickSearchToolbar from "../SharedComponents/QuickSearchToolbar";
import SuccessDialog from "../SharedComponents/SuccessDialog";
import Loader from "../Loader/Loader";
import TemporaryDrawerforUser from "./FilterOptionUser";
import updateErrorList from "../../utils/methods/updateErrorList";
import DialogForNoMatchingResults from "../SharedComponents/DialogForNoMatchingResults";
import DialogForError from "../SharedComponents/DialogForError";
import ToastBarForError from "../SharedComponents/ToastBarForError";
import { userActions } from "../../store/User/user-slice";
import UserPermissions from "../../models/apiModels/UserPermissions";
import RepeatedComponent from "./Details";
import { getLocalTime } from "../../utils/methods/getLocalTime";
import { getNoRowsLabel } from "../../utils/methods/getNoRowsLabel";
import { tenantActions } from "../../store/Tenant/tenant-slice";
import getTenantUsersBasedOnSearchandFilter from "../../utils/methods/getTenantUsersBasedOnSearchandFilter";

function TenantUserPage(props: any) {
  const [userSelected, setUserSelected] = useState({
    customerId: "",
    userId: "",
  });

  const [tenantUsersToDelete, setTenantUsersToDelete] = useState<{
    customerId: string;
    userIds: Array<string>;
  }>({
    customerId: "",
    userIds: [],
  });
  const [open, setOpen] = useState(false);
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);
  const toastErrors = useRef<IErrorProps[]>([]);
  const [searchText, setSearchText] = useState("");
  const [gridData, setGridData] = useState<Array<UserDto>>([]);
  const [tenantCurrentLogo, setCurrentTenantLogo] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingUsers, setIsLoadingUsers] = useState(false);
  const [errorgetUsers, seterrorgetUsers] = useState<Array<IErrorProps>>([]);
  const [errorgetLogo, seterrorgetLogo] = useState<Array<IErrorProps>>([]);
  const [errordeleteUser, seterrordeleteUser] = useState<Array<IErrorProps>>(
    []
  );
  const [errorExportUsers, seterrorExportUsers] = useState<Array<IErrorProps>>(
    []
  );
  const [errorList, setErrorList] = useState<Array<IErrorProps>>([]);
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);
  // This property is intended to be used only for resetting the checkbox selections in the grid
  const [gridDataCopy, setGridDataCopy] = useState<any>([]);
  const userPermissionFetched = useSelector(
    (state: RootState) => state.user.isUserPermissionsFetched
  );

  const userPermissions: UserPermissions = useSelector(
    (state: RootState) => state.user.userPermissions
  );

  const currentTenantIdOfLoadedUsers = useSelector(
    (state: RootState) => state.cart.currentTenantIdOfLoadedUsers
  );
  // istanbul ignore next
  useEffect(() => {
    const mergedErrors = [
      ...errorgetUsers,
      ...errorgetLogo,
      ...errordeleteUser,
      ...errorExportUsers,
    ];
    if (
      mergedErrors.some((x) => x.errorCode === undefined) &&
      !openDialogNoURLError
    ) {
      setOpenDialogNoURLError(true);
    }
    if (mergedErrors.some((x) => x.errorCode === 400) && !openToastError) {
      setOpenToastError(true);
    }
    if (
      mergedErrors.some(
        (x) =>
          x.errorCode !== undefined &&
          x.errorCode !== 400 &&
          x.errorCode !== null &&
          x.errorCode !== 204
      ) &&
      !openDialogServerError
    ) {
      setOpenDialogServerError(true);
    }
    setErrorList(mergedErrors);
  }, [errorgetUsers, errorgetLogo, errordeleteUser, errorExportUsers]);

  // Use Effect // Only intended to set rows selection to default i.e no row selection
  // Intention - When grid rows change the component renders again and the the selected rows become unselected
  // Tried setting rows with copy like [...rows] but that didn't work
  useEffect(() => {
    if (gridData.length === 0 && gridDataCopy.length > 0) {
      setGridData(gridDataCopy);
    }
    setTenantUsersToDelete({
      customerId: "",
      userIds: [],
    });
  }, [gridData]);
  // End Use effect

  /// Get values for tenant user
  const location = useLocation();

  const tenantName = location?.state?.tenantName;
  const tenantDatCentre = location?.state?.datacenter;
  const selectedproducts: OptionsProduct[] = location?.state?.products; // can be used from new response directly instead of maping
  const orgizationName = location?.state?.organizationName ?? "";
  const timezone = location?.state?.timezone;
  const currency = location?.state?.currency;
  const createdOn = location?.state?.createdon;
  const country = location?.state?.country;
  const region = location?.state?.region;
  const headquarterAddress = location?.state?.headquarterAddress ?? "";

  const zipcode = location?.state?.zipcode;
  const state1 = location?.state?.state;

  const tenantID = location?.state?.forgeCustomerId;

  useEffect(() => {
    if (tenantID === "") {
    } else {
      setIsLoading(true);
      dispatch(getTenantLogo(location?.state?.id))
        .unwrap()
        .then((response: any) => {
          setCurrentTenantLogo(response as string);
        })
        .catch((err: any) =>
          seterrorgetLogo(updateErrorList(err, [...errorgetLogo]))
        )
        .finally(() => setIsLoading(false));
    }
  }, [tenantID]);

  const tenantProducts = selectedproducts
    ?.map((x: OptionsProduct) => x.applicationName)
    .join(",")
    .toString();

  const handleClose = () => {
    setOpen(false);
  };
  const handleSuccesssConfirmationClose = () => {
    setSuccessDialogOpen(false);
  };
  // istanbul ignore next

  const handleDeleteConfirmation = () => {
    setOpen(false);
    setIsLoading(true);

    dispatch(deleteTenantUser(tenantUsersToDelete))
      .unwrap()
      .then(() => {
        setUserSelected({
          userId: "",
          customerId: "",
        });

        setTenantUsersToDelete({
          customerId: "",
          userIds: [],
        });
        setSuccessDialogOpen(true);
      })
      .catch((err: any) =>
        seterrordeleteUser(updateErrorList(err, [...errordeleteUser]))
      )
      .finally(() => setIsLoading(false));
  };
  const [progress, setProgress] = useState(0);
  const [toastOpen, settoastOpen] = useState(false);
  const handleCloseToast = () => {
    settoastOpen(false);
  };
  const [refreshKey, setRefreshKey] = useState(0);
  // istanbul ignore next

  const downloadExcel = async () => {
    setIsLoadingUsers(true);
    dispatch(
      exportUserListBasedOnForgeCustomerId(location?.state?.forgeCustomerId)
    )
      .unwrap()
      .then(async (Responsedata) => {
        settoastOpen(true);
        const worksheet = XLSX.utils.json_to_sheet(Responsedata);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        let currentDate = new Date().toJSON().slice(0, 10);
        const fileData = XLSX.writeFile(
          workbook,
          `UDP_Admin-User-Management-${currentDate}.xlsx`
        );
        const blob = new Blob([fileData], { type: "application/octet-stream" });
        const url = URL.createObjectURL(blob);
        const response = await fetch(url);
        const contentLength = response.headers.get("content-length") ?? "100";

        const total = parseInt(contentLength, 10);
        const reader = response.body?.getReader();
        if (!reader) {
          URL.revokeObjectURL(url);
          return;
        }

        let loaded = 0;

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          loaded += value.length;
          const percent = Math.round((loaded / total) * 100);
          setProgress(percent);
        }
        URL.revokeObjectURL(url);
        // TO-DO : remove the animation for setting value back to zero
        await new Promise((resolve) => setTimeout(resolve, 2500));
        settoastOpen(false);
        setProgress(0);
      })
      .catch((err: any) =>
        seterrorExportUsers(updateErrorList(err, [...errorExportUsers]))
      )
      .finally(() => setIsLoadingUsers(false));
  };

  const backButtonHandler = () => {
    if (userPermissions.can_read_tenant) {
      navigate("/tenant");
    } else {
      const error: IErrorProps = {
        errorCode: 403,
        errorMessage: "User doesn't have privileges to List the Tenants",
      };
      const errorListData: IErrorProps[] = [];
      errorListData.push(error);
      toastErrors.current = errorListData;
      setOpenToastError(true);
    }
  };

  const columns: GridColDef[] = [
    {
      field: "firstName",
      headerName: "NAME",
      flex: 1,
      renderCell: (cellValues: any) => {
        const userDetailsInfo = {
          UserInfo: cellValues.row,
          CustomerId: tenantID,
          CustomerDetails: location.state,
        };
        const userName =
          cellValues.row.firstName + " " + cellValues.row.lastName;
        return (
          <Tooltip title={userName} placement="bottom-start">
            <Link
              to="/tenant/user/info"
              state={userDetailsInfo}
              style={{ color: "#64C3FF", textDecoration: "none" }}
            >
              {userName}
            </Link>
          </Tooltip>
        );
      },
    },
    { field: "emailId", headerName: "EMAIL ID", flex: 2 },

    {
      field: "roles",
      headerName: "ROLES",
      sortable: false,
      flex: 2,
      renderCell: (cellValues: any) => {
        if (cellValues && cellValues.row && cellValues.row.roles) {
          return cellValues.row.roles
            .map((x: { name: any }) => x.name)
            .join(",");
        } else {
          return "";
        }
      },
    },

    {
      field: "ACTION",
      flex: 1,
      sortable: false,
      renderCell: (cellValues: any) => {
        // istanbul ignore next
        // Handle Delete
        function handleDelete(
          event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
          cellValues: any
        ) {
          if (userPermissions.can_delete_user) {
            setTenantUsersToDelete({
              customerId: tenantID,
              userIds: [cellValues.row.id],
            });
            setOpen(true);
          } else {
            const error: IErrorProps = {
              errorCode: 403,
              errorMessage: "User Doesn't Have privileges to Delete the Users",
            };
            const errorList: IErrorProps[] = [];
            errorList.push(error);
            setErrorList(errorList);
            setOpenToastError(true);
          }
        }
        // istanbul ignore next
        // Handle edit
        function handleEdit(
          event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
          cellValues: any
        ) {
          // TODO: Edit
          if (userPermissions.can_update_user) {
            setUserSelected({
              customerId: tenantID,
              userId: cellValues.row.id,
            });
            const userDetailsToEdit = {
              CustomerId: tenantID,
              UserInfo: cellValues.row,
            };
            navigate(`/tenant/user/edit`, {
              state: { userDetailsToEdit },
            });
          } else {
            const error: IErrorProps = {
              errorCode: 403,
              errorMessage: "User Doesn't Have privileges to Edit the Users",
            };
            const errorList: IErrorProps[] = [];
            errorList.push(error);
            setErrorList(errorList);
            setOpenToastError(true);
          }
        }

        return (
          <div>
            <Button
              sx={{
                fontSize: 10,
                padding: 0,
                justifyContent: "start",
                color: "#64C3FF",
                textTransform: "none",
                fontFamily: "Honeywell Sans Web",
              }}
              data-testid="editbuttonrow"
              onClick={(event) => {
                handleEdit(event, cellValues);
              }}
            >
              Edit
            </Button>
            <Button
              sx={{
                fontSize: 10,
                padding: 0,
                justifyContent: "start",
                color: "#64C3FF",
                textTransform: "none",
                fontFamily: "Honeywell Sans Web",
              }}
              variant="text"
              color="primary"
              onClick={(event) => {
                handleDelete(event, cellValues);
              }}
            >
              Delete
            </Button>
          </div>
        );
      },
    },
  ];

  const dispatch: AppDispatch = useDispatch();
  const users = useSelector((state: RootState) => state.user.users);
  const [filteringCritera, setFilteringCriteria] = useState<Array<string>>([]);
  const [filteredUsers, setFilteredUsers] = useState<Array<UserDto>>(
    useSelector((state: RootState) => state.user.users)
  );
  useEffect(() => {
    const usersAfterFilter = users.filter((item: UserDto) => {
      return item.roles.some(
        (role: Role) =>
          filteringCritera.length === 0 || filteringCritera.includes(role.name)
      );
    });
    setFilteredUsers(usersAfterFilter);
  }, [filteringCritera, users]);

  useEffect(() => {
    let rolesList: [
      {
        role: Role;
        count: any;
      }
    ] = [
      {
        role: { roleId: "", name: "" },
        count: 0,
      },
    ];
    users.forEach((user: any) => {
      user.roles.forEach((roleData: any) => {
        if (!rolesList.some((item) => item.role.roleId === roleData.roleId)) {
          rolesList.push({ role: roleData, count: 1 });
        } else {
          rolesList.map((roleCountUp) => {
            if (roleCountUp.role.roleId === roleData.roleId) {
              roleCountUp.count = roleCountUp.count + 1;
            }
          });
        }
      });
    });
    rolesList.shift();
  }, [users]);

  useEffect(() => {
    // There is no need to get user list for the tenant as the

    if (!userPermissionFetched) {
      //If user permissions are not fetched Fetch the permissions
      //For Logged in User before performing any action
      setIsLoading(true);
      dispatch(getUserPermissions())
        .unwrap()
        .then((response) => {
          const userPermissionsResponse: UserPermissions = response.result;
          if (userPermissionsResponse.can_read_user) {
            if (
              !(
                currentTenantIdOfLoadedUsers ===
                location?.state?.forgeCustomerId
              )
            ) {
              setIsLoadingUsers(true);
              dispatch(
                getUserListBasedOnForgeCustomerId(
                  location?.state?.forgeCustomerId
                )
              )
                .unwrap()
                .then(() => {
                  dispatch(
                    tenantActions.getCurrentTenantIdOfLoadedUsers(
                      location?.state?.forgeCustomerId
                    )
                  );
                })
                .catch((err: any) => {
                  seterrorgetUsers(updateErrorList(err, [...errorgetUsers]));
                })
                .finally(() => {
                  setIsLoadingUsers(false);
                  setIsLoading(false);
                });
            }
          } else {
            const error: IErrorProps = {
              errorCode: 403,
              errorMessage:
                "User Doesn't Have privileges to List the Tenant Users",
            };
            const errorList: IErrorProps[] = [];
            errorList.push(error);
            setErrorList(errorList);
            setOpenToastError(true);
            setIsLoading(false);
          }
        })
        .catch((err: any) => {
          seterrorgetUsers(updateErrorList(err, [...errorgetUsers]));
        })
        .finally(() => setIsLoading(false));
    } else {
      if (
        !(currentTenantIdOfLoadedUsers === location?.state?.forgeCustomerId)
      ) {
        getTenantUserGridData();
      }
    }
  }, []);

  const getTenantUserGridData = () => {
    setSearchText("");
    setFilteringCriteria([]);
    if (userPermissions.can_read_user) {
      setIsLoadingUsers(true);
      dispatch(
        getUserListBasedOnForgeCustomerId(location?.state?.forgeCustomerId)
      )
        .unwrap()
        .then(() => {
          setRefreshKey((prevKey) => prevKey + 1);
          dispatch(
            tenantActions.getCurrentTenantIdOfLoadedUsers(
              location?.state?.forgeCustomerId
            )
          );
        })
        .catch((err: any) => {
          seterrorgetUsers(updateErrorList(err, [...errorgetUsers]));
        })
        .finally(() => setIsLoadingUsers(false));
    } else {
      const error: IErrorProps = {
        errorCode: 403,
        errorMessage: "User Doesn't Have privileges to List the Tenant Users",
      };
      throwForBiddenError(error);
    }
  };

  useEffect(() => {
    let rolesList: [
      {
        role: Role;
        count: any;
      }
    ] = [
      {
        role: { roleId: "", name: "" },
        count: 0,
      },
    ];
    users.forEach((user: any) => {
      user.roles.forEach((roleData: any) => {
        if (!rolesList.some((item) => item.role.roleId === roleData.roleId)) {
          rolesList.push({ role: roleData, count: 1 });
        } else {
          rolesList.map((roleCountUp) => {
            if (roleCountUp.role.roleId === roleData.roleId) {
              roleCountUp.count = roleCountUp.count + 1;
            }
          });
        }
      });
    });
    rolesList.shift();
    dispatch(setroleList(rolesList));
  }, [users]);

  useEffect(() => {
    let searchedUsers = getTenantUsersBasedOnSearchandFilter(
      filteredUsers,
      searchText
    );

    setGridData(searchedUsers);
    setRefreshKey((prev) => prev + 1);
  }, [filteredUsers]);

  const searchOnchange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };

  useEffect(() => {
    setGridDataCopy([]);
    let searchedUsers = getTenantUsersBasedOnSearchandFilter(
      filteredUsers,
      searchText
    );
    setGridData(searchedUsers);
  }, [searchText]);

  const navigate = useNavigate();
  function throwForBiddenError(error: IErrorProps) {
    const errorListData: IErrorProps[] = [];
    errorListData.push(error);
    toastErrors.current = errorListData;
    setOpenToastError(true);
  }

  function Pagination({
    page,
    onPageChange,
    className,
  }: Pick<TablePaginationProps, "page" | "onPageChange" | "className">) {
    const apiRef = useGridApiContext();
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <MuiPagination
        color="primary"
        className={className}
        count={pageCount}
        page={page + 1}
        onChange={(event, newPage) => {
          onPageChange(event as any, newPage - 1);
        }}
      />
    );
  }
  function CustomPagination(props: any) {
    return <GridPagination sx={{}} ActionsComponent={Pagination} {...props} />;
  }

  // createUserHandler
  // istanbul ignore next
  const createUserHandler = () => {
    if (userPermissions.can_create_user) {
      navigate("/tenant/user/create", { state: { tenantID } });
    } else {
      const error: IErrorProps = {
        errorCode: 403,
        errorMessage: "User Doesn't Have privileges to Create New Tenant Users",
      };
      throwForBiddenError(error);
    }
  };

  // istanbul ignore next
  // reset GridRowSelectionHandler
  const resetGridRowSelectionHandler = () => {
    setTenantUsersToDelete({
      customerId: "",
      userIds: [],
    });
    setGridData([]);
  };

  // istanbul ignore next
  // delete CustomersHandler
  const deleteCustomersHandler = () => {
    if (userPermissions.can_delete_user) {
      setOpen(true);
    } else {
      const error: IErrorProps = {
        errorCode: 403,
        errorMessage: "User doesn't have privileges to Delete the Users",
      };
      throwForBiddenError(error);
    }
  };

  // istanbul ignore next
  // filtering CriteriaChangeHandler
  const filteringCriteriaChangeHandler = (dataFromFilter: Array<string>) => {
    setFilteringCriteria(dataFromFilter);
  };

  // istanbul ignore next
  // customLocaleText
  const customLocaleText = {
    noRowsLabel: getNoRowsLabel(searchText, filteringCritera.length !== 0),
  };

  // Error handling handlers
  // istanbul ignore next
  const onDialogForServerCloseHandler = () => {
    seterrordeleteUser([]);
    setOpenDialogServerError(false);
  };

  // istanbul ignore next
  // on DialogForNOURLCloseHandler
  const onDialogForNOURLCloseHandler = () => {
    setOpenDialogNoURLError(false);
  };

  // istanbul ignore next
  // on handleToastBarClose
  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };

  // removeFilter
  // istanbul ignore next
  const removeFilter = (item: string) => {
    setFilteringCriteria(filteringCritera.filter((x) => x != item));
  };

  // End error handling handlers
  return (
    <>
      <Paper className={classes.paper}>
        <Grid container direction="row" p="1vh" borderColor="black">
          <Grid
            item
            xs={12}
            sx={{
              paddingBottom: "1vh",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Button
              onClick={backButtonHandler}
              data-testid="backButtonHandler"
              sx={{
                color: "#F0F0F0",
                padding: "0vh 0vh 1.2vh 0vh",
                fontSize: "1.1 rem",
                justifyContent: "start",
                minWidth: "1vw",
                minHeight: "0.5vh",
              }}
            >
              <ArrowBackIosIcon sx={{ fontSize: "0.9 rem" }} />
            </Button>
            <Typography className={classes.mainheading}>
              {tenantName}
            </Typography>
          </Grid>
          <Snackbar
            open={toastOpen}
            onClose={handleCloseToast}
            sx={{ width: "30%" }}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          >
            <Alert
              severity="info"
              onClose={handleCloseToast}
              className={classes.exportToast}
            >
              <Grid item md={12}>
                <Typography
                  sx={{ width: "200px", padding: " 5 0 5 0" }}
                  className={classes.exportToastMessage}
                >
                  Datasheet.xslx
                </Typography>
                <LinearProgress
                  sx={{
                    width: "100%",
                    borderRadius: "4px 2px 2px 4px",
                    backgroundColor: "#707070",
                  }}
                  variant="determinate"
                  value={progress}
                />
                <Typography
                  color="inherit"
                  sx={{ width: "200px" }}
                  className={classes.exportToastMessage}
                >
                  Downloading...
                </Typography>
              </Grid>
            </Alert>
          </Snackbar>
          <Grid
            item
            xs={12}
            className={classes.detailsUser}
            sx={{
              minWidth: "1000px",
              minHeight: "150px",
            }}
          >
            <Grid container direction="row" sx={{ minWidth: "900px" }}>
              <Grid
                item
                sx={{
                  paddingTop: "3.2vh",
                  paddingLeft: "1.5vw",
                  width: "10.5vw",
                  minWidth: "100px",
                }}
              >
                {tenantCurrentLogo === "" ? (
                  <Avatar
                    sx={{
                      height: "12vh",
                      width: "12vh",
                      minWidth: "90px",
                      minHeight: "90px",

                      position: "flex",
                    }}
                    alt="Upload Logo"
                    src={editLogo}
                  />
                ) : (
                  <Avatar
                    sx={{
                      height: "12vh",
                      width: "12vh",
                      minWidth: "90px",
                      minHeight: "90px",

                      position: "flex",
                    }}
                    alt="Upload Logo"
                    src={`data:image/jpeg;base64,${tenantCurrentLogo}`}
                  />
                )}
              </Grid>
              <Grid item md={10} xs={10} xl={10}>
                <Grid
                  container
                  sx={{
                    paddingTop: "0.3vh",
                    width: "100%",
                  }}
                >
                  <Grid item sx={{ width: "100%" }}>
                    <Grid>
                      <Typography width="100%" className={classes.headinginfo}>
                        BASIC INFORMATION
                      </Typography>
                    </Grid>
                    <Grid container>
                      <RepeatedComponent
                        label="Name"
                        detail={tenantName}
                        gridsize={1.8}
                      />
                      <RepeatedComponent
                        gridsize={1.8}
                        label="Organization Name"
                        detail={orgizationName}
                      />
                      <RepeatedComponent
                        gridsize={1.8}
                        label="Headquarter Address"
                        detail={headquarterAddress}
                      />
                      <RepeatedComponent
                        gridsize={1.8}
                        label="Country"
                        detail={country}
                      />
                      <RepeatedComponent
                        gridsize={1.8}
                        label="Region"
                        detail={region}
                      />
                      <RepeatedComponent
                        gridsize={1.5}
                        label="State"
                        detail={state1}
                      />
                      <RepeatedComponent
                        gridsize={1.5}
                        label="ZIP Code"
                        detail={zipcode === 0 ? "" : zipcode}
                      />

                      <Grid container sx={{}}>
                        <Grid xs={12} md={12} xl={12}>
                          <Typography
                            width="100%"
                            className={classes.headinginfo}
                          >
                            OTHER INFORMATION
                          </Typography>
                        </Grid>
                        <Grid></Grid>
                        <RepeatedComponent
                          gridsize={1.8}
                          label="Forge Customer ID"
                          detail={tenantID}
                        />
                        <RepeatedComponent
                          gridsize={1.8}
                          label="Currency"
                          detail={currency}
                        />
                        <RepeatedComponent
                          gridsize={1.8}
                          label="Selected Products"
                          detail={tenantProducts}
                        />
                        <RepeatedComponent
                          gridsize={1.8}
                          label="Data Center"
                          detail={tenantDatCentre}
                        />
                        <RepeatedComponent
                          gridsize={1.8}
                          label="Time Zone"
                          detail={timezone}
                        />
                        <RepeatedComponent
                          gridsize={1.8}
                          label="Created On"
                          detail={getLocalTime({
                            utcTime: createdOn,
                            timezone: timezone,
                          })}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sx={{ minWidth: "1000px" }}>
            <Grid container direction="row">
              <Typography
                className={classes.secondaryHeading}
                sx={{
                  marginTop: "0.5vh",
                  marginBottom: "0.5vh",
                }}
              >
                Tenant User List
              </Typography>
              <Box
                sx={{
                  marginLeft: "auto",
                  alignItems: "flex-end",
                  textAlign: "flex-end",
                  paddingRight: "5vh",
                }}
              >
                <Button
                  className={classes.createUser}
                  variant="contained"
                  onClick={createUserHandler}
                  data-testid="createUser"
                >
                  Create New User
                </Button>
              </Box>
            </Grid>
            <Grid
              sx={{
                border: "1px solid #101010",
                boxShadow: " 1px 1px 1px rgba(0, 0, 0, 0.15)",
                height: "45vh",
              }}
            >
              <Card
                sx={{
                  background: "#313030",
                  border: "1px solid #101010",
                  boxShadow: " 1px 1px 1px rgba(0, 0, 0, 0.15)",
                  borderRadius: "1vh",
                  height: "5vh",
                }}
              >
                <Grid md={12} sx={{ paddingTop: 0, paddingBottom: 0 }}>
                  <Box className={classes.lowerCaseHeading} padding={1}>
                    {gridData.length === 1 ? (
                      <span>Total | 1 User</span>
                    ) : (
                      <span>Total | {gridData.length} Users </span>
                    )}
                  </Box>
                </Grid>
              </Card>
              <Grid
                container
                direction="row"
                sx={{ backgroundColor: "#272727" }}
              >
                <Grid item sx={{ padding: "0.5vh", paddingTop: "1.1vh" }}>
                  <TemporaryDrawerforUser
                    isFilterDisabled={isLoading || isLoadingUsers}
                    filteringCritera={filteringCritera}
                    onFilteringCriteriaChange={filteringCriteriaChangeHandler}
                  />
                </Grid>
                <Grid
                  item
                  sx={{
                    padding: "0.7vh",
                    lineHeight: 0,
                  }}
                >
                  <QuickSearchToolbar
                    isDisabled={
                      isLoading || isLoadingUsers || filteredUsers?.length === 0
                    }
                    value={searchText}
                    placeHolderMessage={"Search User"}
                    onChange={(event: any) => searchOnchange(event)}
                  ></QuickSearchToolbar>
                </Grid>
                <Grid
                  p={1}
                  sx={{
                    marginLeft: "auto",
                    alignItems: "flex-end",
                    textAlign: "flex-end",
                    paddingRight: "5vh",
                    height: "1vh",
                    backgroundColor: "#272727",
                  }}
                >
                  <Stack
                    direction="row"
                    spacing={0}
                    sx={{ flexDirection: "row-reverse", height: "5vh" }}
                  >
                    <Tooltip title="Refresh List">
                      <Button
                        data-testid="refreshButton"
                        className={classes.refreshButton}
                        onClick={getTenantUserGridData}
                        sx={{ marginTop: "0.5vh", marginBottom: "1vh" }}
                      >
                        <RefreshIcon
                          sx={{
                            color: "#F0F0F0",
                            fontSize: "2vw",
                            paddingTop: 0,
                          }}
                        />
                      </Button>
                    </Tooltip>
                    <Tooltip title="Download list of all users">
                      <Button
                        data-testid="downloadExcel"
                        onClick={() => downloadExcel()}
                        sx={{
                          marginTop: "0.8vh",
                          marginBottom: "1vh",
                        }}
                      >
                        <img
                          src={image}
                          alt="Button Icon"
                          style={{
                            width: "2vw",
                            paddingTop: 0,
                            paddingBottom: 0,
                          }}
                        />
                      </Button>
                    </Tooltip>
                  </Stack>
                </Grid>
              </Grid>
              <Grid item>
                <Grid
                  container
                  direction="row"
                  sx={{
                    textAlign: "left",
                    background: "#272727",
                    border: "1px solid #101010",
                    fontSize: "0.2 rem",
                    padding: "0.5vh",
                    width: "auto",
                  }}
                >
                  {filteringCritera.length === 0 ? (
                    <Grid className={classes.nofilter}>No filters applied</Grid>
                  ) : (
                    filteringCritera.map((item: any) => (
                      <Grid
                        item
                        className={classes.filterChips}
                        sx={{
                          textAlign: "center",
                          height: "3vh",
                        }}
                      >
                        <>
                          {item}
                          <IconButton
                            className={classes.filterCloseIcon}
                            onClick={() => {
                              removeFilter(item);
                            }}
                            data-testid="imageEdit"
                          >
                            <CloseIcon sx={{ paddingTop: 0 }} />
                          </IconButton>
                        </>
                      </Grid>
                    ))
                  )}
                </Grid>
              </Grid>
              <Grid item md={12}>
                <DataGrid
                  key={refreshKey}
                  loading={isLoadingUsers}
                  checkboxSelection
                  rowHeight={25}
                  columnHeaderHeight={20}
                  columns={columns}
                  rows={gridData}
                  pagination
                  slots={{
                    pagination: CustomPagination,
                  }}
                  initialState={{
                    pagination: {
                      paginationModel: { pageSize: 10, page: 0 },
                    },
                  }}
                  autoHeight={false}
                  disableColumnMenu={true}
                  onRowSelectionModelChange={(ids) => {
                    if (gridData.length !== gridDataCopy.length) {
                      setGridDataCopy(gridData);
                    }
                    setTenantUsersToDelete({
                      customerId: tenantID,
                      userIds: ids.map((x) => x.toString()),
                    });
                  }}
                  sx={{
                    fontFamily: "Honeywell Sans Web",
                    borderBlockColor: "black",
                    border: "black",
                    borderBlockEndColor: "black",
                    background: "#272727",
                    borderColor: "black",
                    fontSize: "0.65rem",
                    height: "28vh",
                    minWidth: "800px",
                  }}
                  localeText={customLocaleText}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {tenantUsersToDelete.userIds.length > 0 && (
          <Grid
            item
            xs={12}
            sx={{
              backgroundColor: "#272727",
              width: "98%",
              border: "1px solid #101010",
              boxShadow:
                "1px 1px 1px rgba(0, 0, 0, 0.15), 1px 1px 1px rgba(0, 0, 0, 0.15)",
              display: "flex",
              position: "fixed",
              bottom: 1,
              height: "7vh",
            }}
          >
            <Grid sx={{ height: "5vh" }}>
              <Button
                color="primary"
                fullWidth
                className={classes.cancelButtonDelete}
                onClick={resetGridRowSelectionHandler}
              >
                Cancel
              </Button>
            </Grid>
            <Grid container justifyContent="flex-end">
              {tenantUsersToDelete?.userIds?.length > 1 && (
                <Button
                  className={classes.deleteButton}
                  variant="contained"
                  onClick={deleteCustomersHandler}
                >
                  Delete{" "}
                </Button>
              )}
            </Grid>
          </Grid>
        )}
      </Paper>

      {open && (
        <DeleteDialog
          open={open}
          title="Delete User"
          handleClose={handleClose}
          DeleteConfirmationMessage={
            tenantUsersToDelete?.userIds?.length > 1
              ? `Do you want to delete ${tenantUsersToDelete?.userIds?.length} users?`
              : "Do you want to delete the user?"
          }
          handleDeleteConfirmation={handleDeleteConfirmation}
        />
      )}
      {successDialogOpen && (
        <SuccessDialog
          open={successDialogOpen}
          title="Successfully Deleted"
          SucessConfirmationMessage="Successfully deleted"
          handleClose={handleSuccesssConfirmationClose}
        />
      )}
      {isLoading && <Loader />}
      {/* /// Error handling logic */}
      {!isLoading && !isLoadingUsers && openDialogServerError && (
        <DialogForError
          open={openDialogServerError}
          onClose={onDialogForServerCloseHandler}
          errorList={errorList}
          errorType="serverError"
        />
      )}
      {/* /// Open NoURL error */}
      {!isLoading && !isLoadingUsers && openDialogNoURLError && (
        <DialogForError
          open={openDialogNoURLError}
          onClose={onDialogForNOURLCloseHandler}
          errorList={errorList}
          errorType="noURLFoundError"
        />
      )}
      {/* /// Open Toast error */}
      {!isLoading && !isLoadingUsers && openToastError && (
        <ToastBarForError
          open={openToastError}
          onClose={handleToastBarClose}
          errorList={errorList.concat(toastErrors.current)}
        />
      )}
      {/* /// End error handling logic */}
    </>
  );
}

export default TenantUserPage;
